export const formatList = (list: Array<string>, locale: string, type: 'conjunction' | 'disjunction'): string =>
  new Intl.ListFormat(locale, { style: 'long', type }).format(list);
